import { gql } from "graphql-request";

export const INVOICE_PURCHASE_BID_FRAGMENT = gql`
  fragment InvoicePurchaseBidFragment on InvoicePurchaseBidType {
    id
    totalPaidOut
    purchasedInvoiceAmount
    commissionPercent
    comparableMonthlyInterestRate
    handlingFeePerInvoice
    monthlyFee
    purchasedAmountPercent
    totalMonthlyCost
    purchaseLimit
    limitFeePerYearPercent
    setupFee
    withRegress
    regressNumDaysAfterDueDate
    paidOutPerInvoice
    paidOutPerInvoicePercent
    comparableYearlyInterestRate
    firstMonthInterestRate
    firstMonthCost
  }
`;

export const COMPANY_LOAN_BID_FRAGMENT = gql`
  fragment CompanyLoanBidFragment on CompanyLoanBidType {
    id
    amount
    paybackTimeMonths
    lenderMonthlyInterest
    monthlyCostWithoutSetupFee
    amortizationMethod
    amortizationMethodDisplayName
    amortizationMethodDescription
    monthlyCost
    totalLoanCost
    createdAt
    updatedAt
    postalFee
    setupFee
    totalCost
    earlyRepaymentFee
    directDebitFee
    isRepayableWithoutFee
    comparableYearlyInterestRate
    firstMonthInterestRate
    comparableMonthlyInterestRate
    firstMonthCost
  }
`;

export const REAL_ESTATE_LOAN_BID_FRAGMENT = gql`
  fragment RealEstateLoanBidFragment on RealEstateBidType {
    id
    amount
    paybackTimeMonths
    lenderMonthlyInterest
    monthlyCostWithoutSetupFee
    amortizationMethod
    amortizationMethodDisplayName
    amortizationMethodDescription
    monthlyCost
    totalLoanCost
    createdAt
    updatedAt
    postalFee
    setupFee
    totalCost
    earlyRepaymentFee
    directDebitFee
    isRepayableWithoutFee
    loanToValueRatio
    comparableYearlyInterestRate
    firstMonthInterestRate
    comparableMonthlyInterestRate
    firstMonthCost
  }
`;

export const LEASING_BID_FRAGMENT = gql`
  fragment LeasingBidFragment on LeasingBidType {
    id
    amount
    paybackTimeMonths
    monthlyPayment
    totalCost
    downPayment
    terminalValue
    setupFee
    contractType
    postalFee
    insuranceMonthlyCost
    comparableYearlyInterestRate
    firstMonthInterestRate
    comparableMonthlyInterestRate
    firstMonthCost
  }
`;

export const REVOLVING_CREDIT_BID_FRAGMENT = gql`
  fragment RevolvingCreditBidFragment on RevolvingCreditBidType {
    id
    createdAt
    updatedAt
    earlyRepaymentFee
    postalFee
    directDebitFee
    setupFee
    amount
    monthlyAmortisation
    lenderMonthlyInterest
    withdrawalFee
    setupFee
    limitFeePerYear
    postalFee
    monthlyPayment
    monthlyCost
    comparableYearlyInterestRate
    firstMonthInterestRate
    comparableMonthlyInterestRate
    firstMonthCost
  }
`;

export const SELECTED_LENDER_RESPONSE_FRAGMENT = gql`
  fragment SelectedLenderResponseFragment on SelectedLenderResponseType {
    id
    signingUrl
    eligibleForPaymentAt
    paidOutAt
    lenderApplication {
      id
      createdAt
      updatedAt
      lenderCompany {
        id
        name
        description
        registeredAtFinansinspektionenAt
        signingUrlTemplate
        customerContactPhoneNumber
        customerContactEmail
        image {
          lowResolutionUrl
        }
      }
    }
  }
`;

export const LENDER_RESPONSE_FRAGMENT = gql`
  fragment LenderResponseFragment on LenderResponseBaseType {
    id
    type
    benefits {
      type
      displayName
      explanation
    }
    promotions {
      type
      value
    }
    attractivenessScore
    isRecommendedSelect
    paidOutAt
    fieldRequests {
      id
      type
      displayName
      field
      isSubmitted
      isCollectedByLender
      lenderComment
    }
    lenderApplication {
      id
      createdAt
      updatedAt
      lenderCompany {
        id
        name
        description
        factoringCompanyDescription
        registeredAtFinansinspektionenAt
        signingUrlTemplate
        image {
          lowResolutionUrl
        }
      }
    }
  }
`;
